import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import './shared/i18n/i18n'
import './styles.css'
import reportWebVitals from './reportWebVitals.ts'
import { ThemeProvider } from './app/theme/ThemeProvider.tsx'
import { App } from './app/App.tsx'
import { resetManagedHead } from './shared/seo/reset-managed-head.ts'

const rootElement = document.getElementById('app')
if (rootElement) {
  resetManagedHead()
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <ThemeProvider defaultTheme="light" storageKey="ui-theme">
        <App />
      </ThemeProvider>
    </StrictMode>,
  )
}

reportWebVitals()
